import { DialogBox, Message, Title } from '@/components/Dialog/DialogComponents';
import { usePageTitle } from '@/hooks/usePageTitle';

export const ACCESS_DENIED_DIALOG_ID = 'access-denied-dialog';

export const AccessDeniedPage = () => {
  usePageTitle('Access Denied');
  return (
    <DialogBox data-testid={ACCESS_DENIED_DIALOG_ID} sx={{ width: '100%' }}>
      <Title>Access Denied</Title>
      <Message>
        You do not have permission to view this page.
        <br />
        If you believe this is an error, please contact your administrator.
      </Message>
    </DialogBox>
  );
};
